import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'unistore/full/react';
import actions from './actions';

export default connect(
  ['user'],
  actions
)(function Settings({ user }) {
  const userImageUrl = user?.images?.[0]?.url;
  const history = useHistory();

  return (
    <div className="Content">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 375 50"
        style={{
          position: 'fixed',
          top: '0',
          backdropFilter: 'blur(20px)',
        }}
      >
        <g onClick={() => history.goBack()}>
          <path fill="#181818" d="M0 0H375V50H0z" fillOpacity="0.7"></path>
          <text
            fill="#fff"
            style={{ whiteSpace: 'pre' }}
            fontSize="16"
            fontWeight="bold"
            letterSpacing="0em"
          >
            <tspan x="156.219" y="31.24">
              Settings
            </tspan>
          </text>
          <path
            fill="#fff"
            d="M27.521 19.38l-.65-.76L18.23 26l8.641 7.38.65-.76L19.77 26l7.751-6.62z"
          ></path>
        </g>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 375 858">
        <path fill="#121212" d="M0 0H375V858H0z"></path>
        <path
          fill="#fff"
          d="M112 810c0-13.255 10.745-24 24-24h120c13.255 0 24 10.745 24 24s-10.745 24-24 24H136c-13.255 0-24-10.745-24-24z"
        ></path>
        <text
          fill="#121212"
          style={{ whiteSpace: 'pre' }}
          fontSize="14"
          fontWeight="bold"
          letterSpacing=".1em"
        >
          <tspan x="160.382" y="814.585">
            LOG OUT
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 738.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="751.24">
            About
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 690.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="703.24">
            Import Your Music
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 642.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="655.24">
            Notifications
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 594.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="607.24">
            Storage
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 546.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="559.24">
            Music Quality
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 498.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="511.24">
            Connected to Apps
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 450.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="463.24">
            Social
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 402.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="415.24">
            Car
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 354.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="367.24">
            Devices
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 306.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="319.24">
            Explicit Content
          </tspan>
        </text>

        <g onClick={() => history.push(`/settings/playback`)}>
          <rect
            fill="#000"
            fillOpacity="0.001"
            height="48"
            width="100%"
            x="0"
            y="242"
          />
          <path
            fill="#B3B3B3"
            d="M348.129 258.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
          ></path>
          <text
            fill="#fff"
            style={{ whiteSpace: 'pre' }}
            fontSize="16"
            fontWeight="450"
            letterSpacing="0em"
          >
            <tspan x="16" y="271.24">
              Playback
            </tspan>
          </text>
        </g>

        <path
          fill="#B3B3B3"
          d="M348.129 210.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="223.24">
            Account
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 162.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="175.24">
            Data Saver
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 94.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#B3B3B3"
          style={{ whiteSpace: 'pre' }}
          fontSize="13"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="84" y="118.257">
            View profile
          </tspan>
        </text>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="84" y="99.24">
            {user?.display_name}
          </tspan>
        </text>
        <circle cx="44" cy="102" r="28" fill="#282828"></circle>
        <path
          fill="#B3B3B3"
          d="M47.962 104.421l-.961-.552a.495.495 0 01-.244-.349.493.493 0 01.112-.409l1.311-1.537A5.493 5.493 0 0049.5 98v-.5a5.521 5.521 0 00-1.74-4.014 5.454 5.454 0 00-4.125-1.475c-2.879.187-5.134 2.673-5.134 5.66v.33c0 1.31.469 2.579 1.319 3.573l1.311 1.538a.493.493 0 01.112.409.489.489 0 01-.243.348l-3.213 1.847A5.514 5.514 0 0035 110.501V112h1v-1.499c0-1.616.874-3.116 2.283-3.917l3.216-1.848c.388-.223.654-.604.73-1.044a1.494 1.494 0 00-.337-1.229l-1.312-1.539A4.5 4.5 0 0139.501 98v-.329c0-2.46 1.845-4.509 4.199-4.66a4.468 4.468 0 013.377 1.205A4.457 4.457 0 0148.5 97.5v.5a4.5 4.5 0 01-1.08 2.925l-1.311 1.537a1.5 1.5 0 00.394 2.274l.479.275c.305-.229.628-.433.98-.59zM52 101.184v5.577a2.993 2.993 0 00-2.013-.788 3.017 3.017 0 00-3.014 3.014 3.017 3.017 0 003.014 3.014A3.017 3.017 0 0053 108.986v-6.071l1.99 1.149.5-.866-3.49-2.014zM49.986 111a2.016 2.016 0 01-2.014-2.014c0-1.11.903-2.014 2.014-2.014a2.015 2.015 0 010 4.028z"
        ></path>
        <circle cx="44" cy="102" r="28" fill={`url(#${userImageUrl})`}></circle>

        <defs>
          <pattern
            id={userImageUrl}
            width="1"
            height="1"
            patternContentUnits="objectBoundingBox"
          >
            <image
              transform="scale(.00156)"
              width="640"
              height="640"
              xlinkHref={userImageUrl}
              preserveAspectRatio="xMidYMin slice"
            ></image>
          </pattern>
        </defs>
      </svg>
    </div>
  );
});
